import React from "react";
import ReactPlayer from "react-player";
import "./AthleteVideo.css";
import "../layout/Spinner.css";

var athleteVideoOne = "None";
var athleteVideoTwo = "None";
var athleteVideoThree = "None";
var athleteVideoFour = "None";

const AthleteVideo = (props) => {
  const athleteVideo = props.athleteVideo;

  if (athleteVideo) {
    if (athleteVideo.videoOne !== "None") {
      athleteVideoOne = (
        <div>
          <p className="videoSubTitle">{athleteVideo.videoOneTitle}</p>
          <div className="AthleteVideoCard">
            <ReactPlayer
              controls={true}
              className="react-player"
              url={athleteVideo.videoOne}
              width="100%"
              height="100%"
            />
          </div>
        </div>
      );
    } else {
      athleteVideoOne = null;
    }
    if (athleteVideo.videoTwo !== "None") {
      athleteVideoTwo = (
        <div>
          <p className="videoSubTitle">{athleteVideo.videoTwoTitle}</p>
          <div className="AthleteVideoCard">
            <ReactPlayer
              controls={true}
              className="react-player"
              url={athleteVideo.videoTwo}
              width="100%"
              height="100%"
            />
          </div>
        </div>
      );
    } else {
      athleteVideoTwo = null;
    }
    if (athleteVideo.videoThree !== "None") {
      athleteVideoThree = (
        <div>
          <p className="videoSubTitle">{athleteVideo.videoThreeTitle}</p>
          <div className="AthleteVideoCard">
            <ReactPlayer
              controls={true}
              className="react-player"
              url={athleteVideo.videoThree}
              width="100%"
              height="100%"
            />
          </div>
        </div>
      );
    } else {
      athleteVideoThree = null;
    }
    if (athleteVideo.videoFour !== "None") {
      athleteVideoFour = (
        <div>
          <p className="videoSubTitle">{athleteVideo.videoFourTitle}</p>
          <div className="AthleteVideoCard">
            <ReactPlayer
              controls={true}
              className="react-player"
              url={athleteVideo.videoFour}
              width="100%"
              height="100%"
            />
          </div>
        </div>
      );
    } else {
      athleteVideoFour = null;
    }

    var displayVideo = null;

    if (
      athleteVideoOne !== null ||
      athleteVideoTwo !== null ||
      athleteVideoThree !== null ||
      athleteVideoFour !== null
    ) {
      displayVideo = (
        <div className="AthleteVideosGroupContainer">
          {athleteVideoOne}
          {athleteVideoTwo}
          {athleteVideoThree}
          {athleteVideoFour}
        </div>
      );
    } else {
      displayVideo = null;
    }

    return displayVideo;
  } else {
    return null;
  }
};

export default AthleteVideo;
